const LOAD_FILTERVALUE = "LOAD_FILTERVALUE";
const LOAD_FILTERVALUE_SUCCESS = "LOAD_FILTERVALUE_SUCCESS";
const LOAD_FILTERVALUE_FAIL = "LOAD_FILTERVALUE_FAIL";
const CLEAN_FILTERVALUE = "CLEAN_FILTERVALUE";

const LOAD_FILTERVALUES = "LOAD_FILTERVALUES";
const LOAD_FILTERVALUES_SUCCESS = "LOAD_FILTERVALUES_SUCCESS";
const LOAD_FILTERVALUES_FAIL = "LOAD_FILTERVALUES_FAIL";

const FILTERVALUE_POST = "FILTERVALUE_POST";
const FILTERVALUE_DELETE = "FILTERVALUE_DELETE";

export default function filterValue(
  state = {
    dataFilterValue: [],
    isLoading: true,
    hasErrored: false,
    message: "",
    data: [],
  },
  action,
) {
  switch (action.type) {
    case LOAD_FILTERVALUE: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case LOAD_FILTERVALUE_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case LOAD_FILTERVALUE_SUCCESS: {
      return Object.assign({}, state, {
        dataFilterValue: action.payload.data,
        isLoading: false,
        hasErrored: false,
      });
    }

    case LOAD_FILTERVALUES: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case LOAD_FILTERVALUES_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case LOAD_FILTERVALUES_SUCCESS: {
      let { data, status } = action.payload;

      return {
        ...state,
        data: status !== 204 ? data : [],
        isLoading: false,
        hasErrored: false,
      };
    }

    case CLEAN_FILTERVALUE: {
      return Object.assign({}, state, {
        dataFilterValue: [],
      });
    }
    default:
      return state;
  }
}

export function getFilterValues() {
  return {
    type: LOAD_FILTERVALUES,
    payload: {
      request: {
        url: "FilterValue",
      },
    },
  };
}

export function getFilterValuesById(id) {
  return {
    type: LOAD_FILTERVALUE,
    payload: {
      request: {
        url: "FilterValue/Filter/" + id,
      },
    },
  };
}

export function addOrEditFilterValue(filterValue, onSuccessCallback = null) {
  return {
    type: FILTERVALUE_POST,
    payload: {
      request: {
        url: "FilterValue",
        method: "POST",
        data: filterValue,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getFilterValuesById(filterValue.filterId));
          dispatch(getFilterValues());
          if (onSuccessCallback && typeof onSuccessCallback === "function") {
            onSuccessCallback();
          }
        },
      },
    },
  };
}
export function deleteFilterValue(id, filterId, onSuccessCallback = null) {
  return {
    type: FILTERVALUE_DELETE,
    payload: {
      request: {
        url: "FilterValue/" + id,
        method: "DELETE",
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getFilterValuesById(filterId));
          if (onSuccessCallback && typeof onSuccessCallback === "function") {
            onSuccessCallback();
          }
        },
      },
    },
  };
}

export function clearFilterValueTable() {
  return {
    type: CLEAN_FILTERVALUE,
  };
}
